import React from 'react';
import { Row, Col } from 'antd';
import Meta from 'antd/lib/card/Meta';
import { Link } from 'react-router-dom';
import {
  SettingOutlined,
  CalculatorOutlined,
  UserOutlined,
} from '@ant-design/icons';
import styles from './settings.module.scss';

const SettingsPage = () => {

  const settingsOption = [
      {
        key: 'profile',
        icon: <UserOutlined style={{ fontSize: 32 }} />,
        title:"User Profile",
        description:"Manage your profile and password in this section",
        url: "/settings/profile",
      },
      {
        key: 'invoiceConfig',
        icon: <SettingOutlined style={{ fontSize: 32 }} />,
        title:"Invoice configurations",
        description:"Add or edit manage Invoice configurations in this section",
        url: "/settings/invoice-configurations",
      },
      {
        key: 'avalara-settings',
        icon: <CalculatorOutlined style={{ fontSize: 32 }} />,
        title:"Tax Settings",
        description:"Manage Avalara tax settings in this section",
        url: "/settings/avalara",
      },
      // {
      //   key: 'rolesPermissions',
      //   icon: <TeamOutlined style={{ fontSize: 32 }} />,
      //   title:"Roles and Permissions",
      //   description:"Add or edit manage roles and permissions in this section",
      //   url: "/settings/roles-permissions",
      // },
  ];

  return (
    <Row
      gutter={{
        xs: 8,
        sm: 16,
        md: 24,
      }}
    >
      {settingsOption.map(setting => (
        <Col
          key={setting.name}
          xs={24}
          sm={24}
          md={12}
          lg={6}
          className="gutter-row"
        >
          <Link to={setting.url} className={styles.configLink}>
            <Meta
              avatar={setting.icon}
              title={setting.title}
              description={setting.description}
              className={styles.configCard}
            />
          </Link>
        </Col>
      ))}
    </Row>
  );
};

export default SettingsPage;
